import { createSlice } from "@reduxjs/toolkit";

const storedAccessToken = localStorage.getItem("accessToken");

const initialState = {
  loading: false,
  success: false,
  accessToken: storedAccessToken || null,
  user: null,
  errorMessage: null,
  isAuthenticated: Boolean(storedAccessToken),
  error: { username: null, password: null },
};

const mergeUserState = (existingUser, incomingUser) => {
  if (incomingUser === null) {
    return null;
  }

  if (incomingUser === undefined) {
    return existingUser;
  }

  const merged = {
    ...(existingUser || {}),
    ...(incomingUser || {}),
  };

  const resolvedEmployeePhoto = incomingUser?.employee_photo
    || existingUser?.employee_photo
    || null;

  const resolvedPhoto = incomingUser?.photo
    || resolvedEmployeePhoto
    || existingUser?.photo
    || null;

  return {
    ...merged,
    photo: resolvedPhoto,
    employee_photo: resolvedEmployeePhoto,
    profile_photo: incomingUser?.profile_photo || existingUser?.profile_photo || null,
  };
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUserData: (state, action) => {
      state.user = mergeUserState(state.user, action.payload);
    },

    setAuthState: (state, action) => {
      const { accessToken, user } = action.payload || {};
      if (accessToken) {
        state.accessToken = accessToken;
        state.isAuthenticated = true;
      }

      if (user !== undefined) {
        state.user = mergeUserState(state.user, user);
      }
    },

    userLoggedIn: (state, action) => {
      const { accessToken, user } = action.payload || {};
      state.isAuthenticated = true;
      state.accessToken = accessToken || state.accessToken;
      state.user = mergeUserState(state.user, user);
    },

    userLoggedOut: (state) => {
      state.isAuthenticated = false;
      state.accessToken = null;
      state.user = null;

      localStorage.removeItem("accessToken");
    },

    resetPassword: (state, action) => {
      state.success = true;
      state.loading = false;
      console.log(action.payload.email);
    },

    requestStart: (state) => {
      state.loading = true;
    },
  },
});

export const {
  setUserData,
  setAuthState,
  userLoggedIn,
  userLoggedOut,
  resetPassword,
  requestStart,
} = authSlice.actions;

export default authSlice.reducer;